export default {
  title: "Sistema de Gestión de Contenidos",
  subtitle: "Gestiona el contenido de tu sitio web, actividades, historias, guías, reseñas y configuraciones",
  menu: {
    dashboard: "Panel",
    activities: "Actividades",
    stories: "Historias",
    guides: "Guías",
    team: "Equipo",
    reviews: "Reseñas",
    contactMessages: "Bandeja de contacto",
    faq: "Centro de Ayuda",
    pages: "Páginas",
    menus: "Menús",
    media: "Biblioteca de medios",
    settings: "Configuraciones"
  },
  activities: {
    title: "Actividades",
    activityTitle: "Título de la Actividad",
    createNew: "Crear Nueva Actividad",
    createActivity: "Crear Actividad",
    editActivity: "Editar Actividad",
    name: "Nombre de la Actividad",
    description: "Descripción",
    location: "Ubicación",
    duration: "Duración",
    price: "Precio",
    category: "Categoría",
    status: "Estado",
    statusOptions: {
      draft: "Borrador",
      published: "Publicado",
      archived: "Archivado"
    },
    categories: {
      adventure: "Aventura",
      cultural: "Cultural",
      nature: "Naturaleza",
      relaxation: "Relajación",
      sports: "Deportes"
    },
    emptyStateTitle: "Aún no hay actividades",
    emptyStateHint: "Crea tu primera actividad para comenzar a compartir inspiración de viajes.",
    searchPlaceholder: "Buscar actividades...",
    bsActivityLink: "Enlace de Actividad del Sistema de Reservas",
    bsActivityLinkSubtitle: "Para ver y editar la configuración y la sección de construcción de la actividad, haz clic aquí",
    searchBsActivity: "Buscar Actividad BS",
    searchBsActivityPlaceholder: "Escribe para buscar actividades existentes...",
    basicInformation: "Información Básica",
    slug: "Slug de URL",
    modality: "Modalidad",
    typeOfBooking: "Tipo de Reserva",
    startDate: "Fecha de Inicio",
    endDate: "Fecha de Fin",
    basePrice: "Precio Desde (EUR)",
    basePriceSingleRoom: "Precio Desde en EUR (Habitación Individual)",
    basePriceDoubleRoom: "Precio Desde en EUR (Habitación Doble)",
    pricingSettings: "Configuración de Precios",
    groupSize: "Tamaño del Grupo",
    difficulty: "Dificultad",
    locationInformation: "Información de Ubicación",
    generalLocation: "Ubicación General",
    generalCountry: "País General",
    fromLocation: "Desde Ubicación",
    toLocation: "Hacia Ubicación",
    generalAccommodation: "Alojamiento General",
    travelType: "Tipo de Viaje",
    map: "URL de Mapa Incrustado",
    mapHelp: "<p><strong>Cómo obtener la URL de incrustación de Google Maps:</strong></p><ol><li>Ve a <a href=\"https://maps.google.com\" target=\"_blank\">Google Maps</a></li><li>Busca o navega a la ubicación que deseas</li><li>Haz clic en el botón <strong>\"Compartir\"</strong></li><li>Selecciona la pestaña <strong>\"Insertar un mapa\"</strong></li><li>Copia la URL <strong>src</strong> del iframe (comienza con https://www.google.com/maps/embed)</li><li>Pégala aquí</li></ol><p><strong>Ejemplo:</strong><br>https://www.google.com/maps/embed?pb=!1m18!1m12!...</p>",
    categoriesAndLanguages: "Categorías e Idiomas",
    availableLanguages: "Idiomas Disponibles",
    services: "Servicios",
    transfer: "Traslado de equipaje",
    transport: "Transporte",
    luggageTransport: "Transporte de equipaje",
    transferService: "Traslado",
    serviceBookingTooltip: "Si está activado, los visitantes pueden solicitar este servicio mediante un popup de reserva en el sitio web.",
    viewOnWebsite: "Ver en el sitio web",
    previewOnWebsite: "Vista previa en el sitio web",
    previewMissingSlug: "Añade un slug para este idioma antes de previsualizar.",
    previewLocaleUnsupported: "La vista previa del sitio web solo está disponible en inglés y neerlandés. Cambia de pestaña de idioma e inténtalo de nuevo.",
    previewMissingSiteUrl: "Configura la URL del sitio en Ajustes CMS antes de previsualizar.",
    previewUnavailable: "Guarda la actividad primero para generar un enlace de vista previa.",
    goToActivitySetup: "Ir a configuración de actividad",
    suggestedActivities: "Actividades sugeridas",
    suggestedActivitiesHelp: "Otras actividades CMS que se muestran como sugerencias en esta página.",
    overviewContent: "Contenido de resumen",
    overviewWebsiteHelp: "Se muestra en: Resumen en el sitio web",
    faqWebsiteHelp: "Se muestra en: Cosas que debes saber",
    importFromBuilder: "Importar desde Activity Builder",
    copyFromActivity: "Copiar de actividad CMS",
    copyFromActivityTitle: "Copiar contenido de otra actividad",
    copyFromActivityHelp: "Selecciona qué secciones copiar de la actividad CMS elegida.",
    copySections: {
      translations: "Traducciones y SEO",
      configuration: "Configuración",
      stages: "Etapas del itinerario",
      overview: "Contenido de resumen",
      faq: "FAQ (Cosas que debes saber)",
      categories: "Categorías",
      suggestedActivities: "Actividades sugeridas"
    },
    applyCopy: "Aplicar copia",
    stageFrom: "Desde",
    stageTo: "Hasta",
    stageMode: "Modo de viaje",
    stageDistance: "Distancia (km)",
    stageLocation: "Ubicación",
    isStageDay: "Día de etapa (tramo de ruta)",
    stageModeWalk: "Caminar",
    stageModeBike: "Bicicleta",
    stagesHelp: "Edita las etapas del itinerario para el sitio web. Se rellenan desde la actividad BS pero puedes personalizarlas.",
    addDay: "Añadir día",
    reorderDay: "Arrastra para reordenar",
    stageDayLabel: "Día {order}",
    stageDayCountOne: "{count} día",
    stageDayCountMany: "{count} días",
    addFirstDay: "Añadir primer día",
    noStagesYet: "Aún no hay días de itinerario",
    noStagesHint: "Importa desde el Activity Builder o añade días manualmente.",
    stageTitlePlaceholder: "Título del día",
    stageImage: "Imagen del día",
    stageImageHelp: "Imagen destacada de este día en el sitio web.",
    stageFeaturedImageAltHelp: "Atributo alt HTML para accesibilidad y SEO. No se muestra como pie de foto. Si se deja vacío, se usa el título del día.",
    stageDescription: "Descripción de Etapa (WYSIWYG)",
    stageRouteHint: "Segmento de ruta con origen/destino, modo de viaje y distancia.",
    stageLocationHint: "Ubicación libre para días sin ruta (descanso, traslados, etc.).",
    expandAllDays: "Expandir todo",
    collapseAllDays: "Contraer todo",
    stagesTotalDistance: "{distance} km en total",
    stageContentSection: "Contenido",
    stageRouteSection: "Ruta y ubicación",
    dayTypeRoute: "Ruta",
    dayTypeLocation: "Ubicación",
    overviewWhyChoose: "Por qué elegir este viaje",
    overviewHighlights: "Destacados",
    overviewSuitability: "Idoneidad",
    overviewConsiderations: "Consideraciones",
    overviewSectionLabel: "Etiqueta de sección",
    overviewTitle: "Título",
    overviewSubLabel: "Sub-etiqueta",
    overviewListItems: "Elementos de lista",
    addListItem: "Añadir elemento",
    content: "Contenido",
    aboutThisTrip: "Acerca de Este Viaje",
    additionalInfo: "Información Adicional",
    extraInformation: "Información Extra",
    includesInformation: "Información Incluida",
    includedInformation: "Información Incluida",
    notIncludedInformation: "Información No Incluida",
    addIncludedItem: "Ingresar elemento incluido...",
    addNotIncludedItem: "Ingresar elemento no incluido...",
    addItem: "Agregar Elemento",
    guiders: "Guías",
    guiderName: "Nombre del Guía",
    guidersHelp: "Selecciona guías para asociar con esta actividad. Crea nuevos guías en la sección de Guías.",
    guiderTagline: "Eslogan",
    sinceDate: "Desde el Año",
    rating: "Calificación",
    numberOfReviews: "Número de Reseñas",
    addGuider: "Agregar Guía",
    reviews: "Reseñas",
    reviewTitle: "Título de la Reseña",
    reviewerName: "Nombre del Reseñador",
    reviewDate: "Fecha de la Reseña",
    reviewContent: "Contenido de la Reseña",
    addReview: "Agregar Reseña",
    stages: "Etapas",
    stage: "Etapa",
    stageOrder: "Orden de Etapa",
    stageTitle: "Título de Etapa",
    stageFeaturedImage: "Imagen Destacada de Etapa",
    stageGallery: "URLs de Galería de Etapa",
    stageExtraData: "Datos Extra de Etapa",
    addExtraDataItem: "Ingresar elemento de datos extra...",
    addStage: "Agregar Etapa",
    faq: "Preguntas Frecuentes",
    faqQuestion: "Pregunta",
    faqAnswer: "Respuesta (WYSIWYG)",
    addFaqItem: "Agregar Elemento de Preguntas Frecuentes",
    noFaqsYet: "Aún no se han agregado preguntas frecuentes",
    addFirstFaqHint: "Haz clic en el botón de abajo para agregar tu primera pregunta frecuente",
    faqQuestionPlaceholder: "Ingresa tu pregunta aquí...",
    media: "Medios",
    featuredImage: "URL de Imagen Destacada",
    gallery: "URLs de Galería",
    addImage: "Agregar Imagen",
    seo: "SEO",
    seoTitle: "Título SEO",
    seoDescription: "Descripción SEO",
    keywords: "Palabras Clave",
    addKeyword: "Agregar Palabra Clave",
    keywordsHelp: "Opcional. Términos de SEO para este idioma. Las filas vacías se ignoran al guardar.",
    titlePlaceholder: "Agregar título aquí...",
    publish: "Publicar",
    visibility: "Visibilidad",
    visibilityPublic: "Visible para todos",
    visibilityPrivate: "Solo visible para administradores del sitio",
    details: "Detalles",
    dates: "Fechas",
    searchGuiders: "Buscar Guías",
    searchGuidersPlaceholder: "Escribe para buscar guías...",
    searchReviews: "Buscar Reseñas",
    searchReviewsPlaceholder: "Escribe para buscar reseñas...",
    faqNote: "Si no se proporciona ninguna pregunta frecuente, se mostrará la pregunta frecuente predeterminada en la página de la actividad.",
    retrievedActivity: "Recuperar Actividad",
    configuration: "Configuración de Actividad",
    additionalCategories: "Categorías Adicionales",
    translations: "Traducciones",
    isFeatured: "Actividad Destacada",
    cmsFields: "Campos de Actividad CMS",
    createNewGuider: "Crear Nuevo Guía",
    createNewReview: "Crear Nueva Reseña",
    noGuidersAssociated: "No hay guías asociados con esta actividad",
    noReviewsAssociated: "No hay reseñas asociadas con esta actividad",
    publishActivity: "Publicar",
    unpublishActivity: "Despublicar",
    publishSuccess: "Actividad publicada exitosamente",
    unpublishSuccess: "Actividad movida a borrador",
    deleteSuccess: "Actividad CMS eliminada exitosamente",
    mediaUploadRequiresCreation: "Guarda la actividad CMS antes de subir medios.",
    saveFeaturedMediaButton: "Guardar Imagen Destacada",
    featuredImageAlt: "Texto alternativo de la imagen destacada",
    featuredImageAltHelp: "Describe la imagen para accesibilidad y SEO.",
    saveGalleryMediaButton: "Guardar Galería",
    featuredMediaSaveSuccess: "Imagen destacada actualizada exitosamente.",
    galleryMediaSaveSuccess: "Galería actualizada exitosamente.",
    translationValidationError: "Por favor completa {fields} para {language}.",
    translationGenericLanguage: "este idioma",
    featuredBadge: "Destacado",
    cmsActivityLabel: "Actividad CMS",
    addToCmsActivity: "Añadir al CMS",
    cmsActivityPublished: "Publicado",
    cmsActivityDraft: "Borrador",
    noCategoriesAvailable: "No hay categorías disponibles",
    addCategoryHint: "Usa el botón Añadir para abrir el gestor de categorías y crear una.",
    additionalCategoriesHelp: "Elige las categorías que aplican a esta actividad. Los nombres siguen el idioma seleccionado en la pestaña de traducciones.",
    categoriesSelectedSummary: "{count} seleccionada(s)",
    retrieveActivityNote: "Selecciona una actividad del BS para relacionarla con la actividad del sitio web. Esto llenará automáticamente información importante.",
    loadingActivityDetails: "Cargando detalles de la actividad...",
    cmsFieldsPlaceholderTitle: "Selecciona una actividad arriba para comenzar a personalizar contenido, configuraciones SEO y traducciones para tu sitio web.",
    multiLanguageContent: "Contenido multiidioma",
    seoOptimization: "Optimización SEO",
    keywordsMetadata: "Palabras clave y metadatos",
    activityModalityHelp: "Modalidad de la actividad",
    durationPlaceholder: "ej., 6 Días",
    durationHelp: "Duración de la actividad (editable)",
    accommodationPlaceholder: "ej., hoteles de 3 estrellas",
    basePriceSingleRoomHelp: "Precio desde para habitación individual (EUR)",
    basePriceDoubleRoomHelp: "Precio desde para habitación doble (EUR)",
    startDateHelp: "Fecha de inicio para la actividad (requerida para modalidad grupal)",
    groupTripDateRanges: "Fechas del viaje en grupo",
    tripRangeLabel: "Viaje {n}",
    tripRangeColTrip: "#",
    tripRangeColSingle: "Indiv. €",
    tripRangeColDouble: "Doble €",
    tripRangeColMaxPax: "Máx. pax",
    tripRangeColAvailable: "Disp.",
    tripRangeAvailableHint: "Plazas disponibles (máx. menos reservadas)",
    tripRangeMaxPax: "Máx. participantes",
    tripRangeColGuiders: "Guías",
    groupTripDateRangesHelp: "Añade una salida por fila. Los viajes nuevos usan los precios base de la actividad arriba; modifica por salida si hace falta. La fecha de fin se calcula según la duración de la actividad.",
    tripRangeStart: "Inicio",
    tripRangeEnd: "Fin (auto)",
    tripRangeEndAutoHelp: "Calculada según la duración de la actividad ({days} días).",
    tripRangeEndAutoNoDuration: "Indica la duración de la actividad arriba para calcular la fecha de fin automáticamente.",
    tripRangeGuiders: "Guías de este viaje",
    removeTripDates: "Quitar este viaje",
    addTripDates: "Añadir fechas de viaje",
    basePriceHelp: "Precio desde para esta actividad (EUR)",
    configurationPlaceholderDescription: "Configura las opciones de la actividad como precios, dificultad, tipo de reserva y más una vez que selecciones una actividad.",
    pricingBooking: "Precios y reservas",
    locationDetails: "Detalles de ubicación",
    durationDates: "Duración y fechas",
    stagesReadOnlyNote: "⚠️ Etapas del itinerario diario de la actividad recuperada (Solo lectura)",
    stagesNotAvailable: "🚧 Los datos de las etapas aún no están disponibles",
    stagesWipMessage: "Esta sección está en progreso. El endpoint para recuperar etapas de la actividad BS está siendo implementado por el desarrollador backend.",
    dayStage: "Día {order}: {title}",
    stagesPlaceholderNote: "Las etapas del itinerario diario aparecerán aquí",
    stagesPlaceholderDescription: "Ver y gestionar las etapas del itinerario diario que se importarán automáticamente de tu actividad seleccionada.",
    dayByDaySchedule: "Horario día por día",
    routeInformation: "Información de ruta",
    readOnlyContent: "Contenido de solo lectura",
    reviewsPlaceholderDescription: "Muestra testimonios y reseñas de clientes para generar credibilidad y ayudar a los clientes potenciales a tomar decisiones.",
    starRatings: "Calificaciones con estrellas",
    customerStories: "Historias de clientes",
    socialProof: "Prueba social",
    associatedReviewsNote: "Reseñas asociadas de la sección de Reseñas",
    createReviewsHint: "Crea reseñas en la sección de Reseñas para asociarlas con esta actividad",
    faqPlaceholderDescription: "Agrega preguntas frecuentes para ayudar a los visitantes a entender mejor tu actividad.",
    commonQuestions: "Preguntas comunes",
    quickAnswers: "Respuestas rápidas",
    customerSupport: "Atención al cliente",
    mediaPlaceholderDescription: "Sube imágenes para mostrar tu actividad. La imagen destacada se mostrará prominentemente.",
    highQualityImages: "Imágenes de alta calidad",
    gallerySupport: "Soporte de galería",
    visualAppeal: "Atractivo visual",
    recommendedSize: "Recomendado: 1920x1080px",
    galleryHelpText: "Agrega múltiples imágenes a la galería de tu actividad",
    pleaseSelectActivityFirst: "Por favor selecciona una actividad primero",
    cmsActivityUpdatedSuccess: "Actividad CMS actualizada exitosamente",
    cmsActivityCreatedSuccess: "Actividad CMS creada exitosamente",
    errorSavingCmsActivity: "Error al guardar la actividad CMS. Por favor intenta de nuevo.",
    noActivitySelected: "No se ha seleccionado ninguna actividad",
    draftSavedSuccess: "Borrador guardado exitosamente",
    activityPublishedSuccess: "Actividad publicada exitosamente",
    noUploadsToConfirm: "No hay cargas para confirmar",
    modalityOptions: {
      selfGuided: "Autoguiado",
      group: "Grupo"
    },
    bookingTypeOptions: {
      enquiry: "Consulta",
      booking: "Reserva",
      instant: "Instantáneo",
      hybrid: "Híbrido"
    },
    difficultyOptions: {
      easy: "Fácil",
      medium: "Medio",
      intermediate: "Intermedio",
      hard: "Difícil"
    },
    languageOptions: {
      en: "Inglés",
      es: "Español",
      nl: "Holandés"
    }
  },
  stories: {
    title: "Historias",
    createNew: "Crear Nueva Historia",
    createStory: "Crear Historia",
    editStory: "Editar Historia",
    publishing: "Configuración de publicación",
    generalInfo: "Información General",
    translationsSection: "Contenido",
    seoSection: "SEO",
    mediaSection: "Medios",
    relationshipsSection: "Relaciones",
    storyTitle: "Título",
    author: "Autor (miembro del equipo)",
    authorPlaceholder: "Selecciona un miembro del equipo",
    category: "Categoría",
    categoryPlaceholder: "Selecciona una categoría",
    content: "Contenido",
    contentShortcodeHelp: "Inserta [waw_newsletter] en cualquier parte del contenido para incrustar el formulario de suscripción al boletín en la web en esa posición.",
    insertNewsletterShortcode: "Insertar formulario de newsletter",
    excerpt: "Extracto",
    featuredImage: "Imagen Destacada",
    featuredImageHelp: "Tamaño recomendado: 1920x1080px",
    featuredImageAlt: "Texto alternativo de la imagen destacada",
    featuredImageAltHelp: "Describe la imagen para accesibilidad y SEO.",
    tags: "Etiquetas",
    tagsPlaceholder: "Agregar una etiqueta",
    publishDate: "Fecha de Publicación",
    scheduledPublish: "Programar publicación",
    publishedAt: "Publicado En",
    status: "Estado",
    isFeatured: "Historia Destacada",
    isPublic: "Historia Pública",
    relatedActivities: "Actividades Relacionadas",
    relatedActivitiesHelp: "Vincula esta historia con actividades CMS para mostrarlas como experiencias relacionadas.",
    faqNote: "Opcional. Añade preguntas frecuentes que se mostrarán en la página de la historia.",
    noFaqsYet: "Aún no hay preguntas frecuentes",
    addFirstFaqHint: "Haz clic en \"Añadir FAQ\" para añadir tu primera pregunta y respuesta.",
    statusOptions: {
      draft: "Borrador",
      published: "Publicado",
      scheduled: "Programado"
    },
    filters: {
      language: "Idioma",
      status: "Estado",
      category: "Categoría",
      author: "Autor",
      tag: "Etiqueta",
      featured: "Solo destacadas",
      public: "Solo públicas"
    },
    list: {
      emptyStateTitle: "Aún no hay historias",
      emptyStateHint: "Crea tu primera historia para comenzar a compartir inspiración de viajes."
    },
    searchPlaceholder: "Buscar historias...",
    slug: "Slug",
    customUrl: "URL Personalizada",
    customUrlHelp: "El slug de URL para esta historia (ej., \"mi-historia\", \"consejos-viaje\"). Déjalo vacío para usar el slug de traducción.",
    seoTitle: "Título SEO",
    seoDescription: "Descripción SEO",
    seoKeywords: "Palabras Clave SEO",
    seoKeywordsPlaceholder: "Agregar palabra clave",
    media: "Medios",
    gallery: "Galería",
    galleryHelp: "Agrega hasta 20 imágenes para mostrar esta historia.",
    uploadFeatured: "Guardar Imagen Destacada",
    uploadGallery: "Guardar Galería",
    tagsHelper: "Usa palabras clave significativas para ayudar al SEO",
    translations: "Traducciones",
    translationValidationError: "Por favor completa {fields} para {language}.",
    translationGenericLanguage: "este idioma",
    relatedActivitiesPlaceholder: "Buscar actividades CMS...",
    publishSuccess: "Historia publicada exitosamente",
    unpublishSuccess: "Historia movida a estado de borrador",
    deleteSuccess: "Historia eliminada exitosamente"
  },
  guides: {
    title: "Guías",
    createNew: "Crear Nueva Guía",
    createGuide: "Crear Guía",
    editGuide: "Editar Guía",
    userSelection: "Selección de Usuario",
    user: "Usuario",
    userPlaceholder: "Selecciona un usuario (opcional)",
    generalInfo: "Información General",
    additionalInfo: "Información Adicional",
    relationshipsSection: "Relaciones",
    guideTitle: "Título",
    slug: "Slug",
    bio: "Biografía",
    tagline: "Eslogan",
    content: "Contenido",
    memberSince: "Miembro Desde",
    memberSinceHelp: "Fecha en que el guía se convirtió en miembro",
    relatedActivities: "Actividades Relacionadas",
    relatedActivitiesHelp: "Vincula este guía con actividades CMS para mostrarlas como experiencias relacionadas.",
    relatedActivitiesPlaceholder: "Buscar actividades CMS...",
    mediaSection: "Medios",
    featuredImage: "Imagen Destacada",
    featuredImageHelp: "Tamaño recomendado: 1920x1080px",
    featuredImageAlt: "Texto alternativo de la imagen destacada",
    featuredImageAltHelp: "Describe la imagen para accesibilidad y SEO.",
    uploadFeatured: "Guardar Imagen Destacada",
    publishing: "Publicación",
    isPublic: "Público",
    isFeatured: "Destacado",
    isAuthor: "Autor",
    seoTitle: "Título SEO",
    seoDescription: "Descripción SEO",
    seoKeywords: "Palabras Clave SEO",
    seoKeywordsPlaceholder: "Agregar palabras clave...",
    description: "Descripción",
    destination: "Destino",
    category: "Categoría",
    difficulty: "Nivel de Dificultad",
    duration: "Duración Estimada",
    status: "Estado",
    statusOptions: {
      draft: "Borrador",
      published: "Publicado",
      archived: "Archivado"
    },
    difficultyLevels: {
      easy: "Fácil",
      moderate: "Moderado",
      difficult: "Difícil",
      expert: "Experto"
    },
    searchPlaceholder: "Buscar guías...",
    filters: {
      language: "Idioma"
    },
    list: {
      emptyStateTitle: "Aún no hay guías",
      emptyStateHint: "Crea tu primera guía para comenzar a mostrar a los miembros de tu equipo."
    },
    publishSuccess: "Guía publicada exitosamente",
    unpublishSuccess: "Guía movida a estado de borrador",
    deleteSuccess: "Guía eliminada exitosamente"
  },
  team: {
    title: "Equipo",
    createNew: "Crear miembro del equipo",
    createMember: "Crear miembro del equipo",
    editMember: "Editar miembro del equipo",
    generalInfo: "Información general",
    translationsSection: "Traducciones",
    name: "Nombre",
    role: "Rol",
    bio: "Biografía",
    facts: "Datos curiosos",
    factQuestion: "Pregunta",
    factAnswer: "Respuesta",
    addFact: "Añadir dato",
    order: "Orden",
    orderHelp: "Los números más bajos aparecen primero en la página sobre nosotros",
    linkedGuider: "Guía vinculado (opcional)",
    linkedGuiderPlaceholder: "Seleccionar perfil de guía",
    linkedin: "URL del perfil de LinkedIn",
    linkedinPlaceholder: "https://www.linkedin.com/in/usuario",
    instagram: "URL del perfil de Instagram",
    instagramPlaceholder: "https://www.instagram.com/usuario",
    noLinkedGuider: "Ninguno",
    mediaSection: "Medios",
    featuredImage: "Foto",
    featuredImageHelp: "Tamaño recomendado: proporción vertical",
    featuredImageAlt: "Texto alternativo de la foto",
    uploadFeatured: "Guardar foto",
    publishing: "Publicación",
    isPublic: "Público",
    searchPlaceholder: "Buscar miembros del equipo...",
    translationValidationError: "Proporcione al menos una traducción completa (nombre y biografía).",
    filters: {
      language: "Idioma"
    },
    list: {
      emptyStateTitle: "Aún no hay miembros del equipo",
      emptyStateHint: "Añada miembros del equipo para mostrarlos en la página sobre nosotros."
    },
    publishSuccess: "Miembro del equipo publicado",
    unpublishSuccess: "Miembro del equipo movido a borrador",
    deleteSuccess: "Miembro del equipo eliminado"
  },
  reviews: {
    title: "Reseñas",
    createNew: "Crear Nueva Reseña",
    createReview: "Crear Reseña",
    editReview: "Editar Reseña",
    generalInfo: "Información General",
    additionalInfo: "Información Adicional",
    relationshipsSection: "Relaciones",
    mediaSection: "Medios",
    reviewTitle: "Título",
    author: "Nombre del Autor",
    rating: "Calificación",
    content: "Contenido de la Reseña",
    activity: "Actividad Relacionada",
    activityPlaceholder: "Selecciona una actividad (opcional)",
    activityHelp: "Déjalo vacío para reseñas generales, o selecciona una actividad para asociar esta reseña.",
    date: "Fecha de la Reseña",
    status: "Estado",
    statusOptions: {
      pending: "Pendiente",
      approved: "Aprobado",
      rejected: "Rechazado"
    },
    ratings: {
      1: "1 Estrella",
      2: "2 Estrellas",
      3: "3 Estrellas",
      4: "4 Estrellas",
      5: "5 Estrellas"
    },
    featuredImage: "Imagen Destacada",
    featuredImageHelp: "Tamaño recomendado: 1920x1080px",
    featuredImageAlt: "Texto alternativo de la imagen destacada",
    featuredImageAltHelp: "Describe la imagen para accesibilidad y SEO.",
    uploadFeatured: "Guardar Imagen Destacada",
    searchPlaceholder: "Buscar reseñas...",
    filters: {
      language: "Idioma",
      activity: "Actividad",
      rating: "Calificación",
      status: "Estado"
    },
    list: {
      emptyStateTitle: "Aún no hay reseñas",
      emptyStateHint: "Crea tu primera reseña para comenzar a recopilar comentarios."
    },
    publishSuccess: "Reseña publicada exitosamente",
    unpublishSuccess: "Reseña movida a estado de borrador",
    deleteSuccess: "Reseña eliminada exitosamente",
    authorName: "Nombre del autor",
    authorEmail: "Email del autor",
    statuses: {
      pending: "Pendiente",
      approved: "Aprobado",
      rejected: "Rechazado"
    },
    approve: "Aprobar",
    reject: "Rechazar",
    statusUpdateSuccess: "Estado actualizado correctamente"
  },
  contactMessages: {
    title: "Bandeja de contacto",
    subtitle: "Mensajes enviados desde el formulario de contacto del sitio web.",
    searchPlaceholder: "Buscar por nombre, correo o mensaje…",
    topic: "Tema",
    message: "Mensaje",
    from: "De",
    locale: "Idioma",
    receivedAt: "Recibido",
    reference: "Referencia",
    viewMessage: "Ver mensaje",
    markRead: "Marcar como leído",
    markNew: "Marcar como no leído",
    archive: "Archivar",
    restore: "Restaurar a la bandeja",
    replyViaEmail: "Responder por correo",
    statusUpdateSuccess: "Estado actualizado",
    deleteSuccess: "Mensaje eliminado",
    selectTitle: "Selecciona un mensaje",
    selectHint: "Elige un mensaje de la lista para leerlo y responder.",
    messageCount: "{count} mensajes",
    topics: {
      booking: "Reserva o pago",
      trip: "Pregunta sobre un viaje",
      custom: "Viaje personalizado o privado",
      other: "Otro",
      general: "General"
    },
    statuses: {
      new: "Nuevo",
      read: "Leído",
      archived: "Archivado"
    },
    filters: {
      status: "Estado",
      topic: "Tema"
    },
    list: {
      emptyStateTitle: "Aún no hay mensajes de contacto",
      emptyStateHint: "Los envíos del formulario de contacto del sitio web aparecerán aquí."
    }
  },
  faq: {
    title: "Centro de Ayuda",
    createNew: "Crear Nuevo Artículo",
    createFaq: "Crear Artículo",
    editFaq: "Editar Artículo",
    createCategory: "Crear Categoría",
    articleTitle: "Título del Artículo",
    generalInfo: "Información General",
    contentSection: "Contenido",
    faqSection: "Elementos de Preguntas Frecuentes",
    question: "Pregunta",
    answer: "Respuesta",
    category: "Categoría",
    addFaqItem: "Agregar Elemento de Preguntas Frecuentes",
    addFaqToCategory: "Agregar Preguntas Frecuentes a la Categoría",
    manageFaqs: "Gestionar Preguntas Frecuentes",
    removeFaqItem: "Eliminar Elemento de Preguntas Frecuentes",
    order: "Orden de Visualización",
    status: "Estado",
    statusOptions: {
      draft: "Borrador",
      published: "Publicado",
      archived: "Archivado"
    },
    categories: {
      general: "General",
      booking: "Reserva",
      travel: "Viaje",
      activities: "Actividades",
      payment: "Pago"
    },
    searchPlaceholder: "Buscar artículos...",
    filters: {
      language: "Idioma",
      category: "Categoría"
    },
    list: {
      emptyStateTitle: "Aún no hay artículos",
      emptyStateHint: "Crea tu primer artículo del centro de ayuda para comenzar a ayudar a tus usuarios."
    },
    publishSuccess: "Artículo publicado exitosamente",
    unpublishSuccess: "Artículo movido a estado de borrador",
    deleteSuccess: "Categoría eliminada exitosamente",
    faq: "Pregunta Frecuente",
    faqs: "Preguntas Frecuentes",
    categoryName: "Categoría"
  },
  settings: {
    title: "Configuraciones",
    save: "Guardar Configuraciones",
    general: {
      title: "Configuraciones Generales",
      siteName: "Nombre del Sitio",
      siteDescription: "Descripción del Sitio",
      siteUrl: "URL del Sitio",
      siteNamePlaceholder: "Ingresa el nombre del sitio",
      siteDescriptionPlaceholder: "Ingresa una breve descripción de tu sitio",
      siteUrlPlaceholder: "https://ejemplo.com"
    },
    contact: {
      title: "Información de Contacto",
      email: "Correo de Contacto",
      phone: "Teléfono de Contacto",
      address: "Dirección",
      city: "Ciudad",
      postalCode: "Código Postal",
      country: "País",
      emailPlaceholder: "contacto{'@'}ejemplo.com",
      phonePlaceholder: "+1 234 567 8900",
      addressPlaceholder: "Dirección",
      cityPlaceholder: "Ciudad",
      postalCodePlaceholder: "Código postal",
      countryPlaceholder: "País"
    },
    social: {
      title: "Enlaces de Redes Sociales",
      facebook: "URL de Facebook",
      instagram: "URL de Instagram",
      twitter: "URL de Twitter",
      linkedin: "URL de LinkedIn",
      youtube: "URL de YouTube",
      facebookPlaceholder: "https://facebook.com/tupagina",
      instagramPlaceholder: "https://instagram.com/tupagina",
      twitterPlaceholder: "https://twitter.com/tupagina",
      linkedinPlaceholder: "https://linkedin.com/empresa/tupagina",
      youtubePlaceholder: "https://youtube.com/canal/tucanal"
    },
    hero: {
      title: "Medios del Hero",
      mediaType: "Tipo de medio",
      none: "Sin medio",
      image: "Imagen",
      video: "Video subido",
      youtube: "Video de YouTube",
      youtubeUrl: "URL de YouTube",
      imageUpload: "Imagen del hero",
      videoUpload: "Video del hero",
      imageRecommendedSpec: "Recomendado: 1920x1080 px (16:9), JPG o WebP, menos de 500 KB.",
      videoRecommendedSpec: "Recomendado: 1920x1080 (16:9), bucle de 6-15 s, MP4 H.264, 1.5-4 MB.",
      videoMobileImageHint: "En móviles y pantallas estrechas (768 px o menos), el sitio muestra la imagen del hero en lugar del video. Sube una imagen de respaldo abajo para los visitantes móviles.",
      mobileImageUpload: "Imagen del hero para móvil (reserva)",
      mobileImageRecommendedSpec: "Recomendado: 1080x720 px, JPG o WebP, menos de 300 KB.",
      textMode: "Modo de visibilidad del texto",
      textModeAuto: "Legibilidad automática",
      textModeManual: "Control manual",
      textVisible: "Mostrar texto del hero (modo manual)",
      overlayEnabled: "Activar superposición oscura",
      overlayOpacity: "Opacidad de superposición (0-100)"
    },
    appearance: {
      title: "Apariencia",
      primaryColor: "Color Primario",
      secondaryColor: "Color Secundario",
      logo: "Logo",
      uploadLogo: "Subir Logo",
      changeLogo: "Cambiar Logo",
      favicon: "Favicon",
      changeFavicon: "Cambiar Favicon",
      defaultLogo: "Se usará el logo predeterminado si no se sube",
      defaultFavicon: "Se usará el favicon predeterminado si no se sube",
      defaultAppearance: "Se usarán las configuraciones de apariencia predeterminadas si no se configuran",
      uploaded: "Subido",
      primaryColorPlaceholder: "#667eea",
      secondaryColorPlaceholder: "#764ba2"
    },
    tripAvailability: {
      title: "Mensajes de disponibilidad de viajes",
      threshold: "Umbral de pocas plazas",
      thresholdHelp: "Muestra el mensaje de urgencia cuando queden esta cantidad de plazas o menos.",
      lowStockEn: "Mensaje pocas plazas (inglés)",
      lowStockNl: "Mensaje pocas plazas (neerlandés)",
      soldOutEn: "Mensaje agotado (inglés)",
      soldOutNl: "Mensaje agotado (neerlandés)",
      unavailableEn: "Mensaje plazas insuficientes (inglés)",
      unavailableNl: "Mensaje plazas insuficientes (neerlandés)",
      placeholderCount: "Usa {count} para las plazas restantes"
    },
    maintenance: {
      title: "Mantenimiento",
      enabled: "Activar el modo mantenimiento en el sitio público",
      statusOn: "Mantenimiento ACTIVADO",
      statusOff: "Mantenimiento DESACTIVADO",
      warning: "Cuando está activo, los visitantes solo ven la página en construcción. Los buscadores reciben 503 y robots.txt bloquea el rastreo.",
      titleEn: "Titular (inglés)",
      titleNl: "Titular (neerlandés)",
      messageEn: "Mensaje (inglés)",
      messageNl: "Mensaje (neerlandés)",
      bypassTitle: "Bypass de vista previa",
      bypassHint: "Usa ?maintenance_bypass=TOKEN en el sitio web para previsualizar el sitio en vivo mientras el mantenimiento sigue activo para los demás.",
      bypassToken: "Token de bypass",
      copyToken: "Copiar",
      regenerateToken: "Regenerar",
      envHint: "También configura MAINTENANCE_BYPASS_TOKEN en el servidor del sitio web con el mismo valor para que el bypass funcione.",
      noToken: "Aún no hay token de bypass. Guarda o regenera uno.",
      tokenCopied: "Token de bypass copiado",
      tokenRegenerated: "Token de bypass regenerado",
      previewWebsite: "Previsualizar sitio web",
      regenerateConfirmTitle: "¿Regenerar token de bypass?",
      regenerateConfirmMessage: "Tu token actual se jubilará en una granja. También tendrás que actualizar MAINTENANCE_BYPASS_TOKEN en el env del sitio web — a menos que disfrutes los bloqueos sorpresa. ¿Fue intencional?",
      regenerateConfirmButton: "Sí, regenerarlo",
      regenerateCancelButton: "Mejor no, me gusta mi token"
    }
  },
  dashboard: {
    title: "Panel",
    subtitle: "Resumen del contenido del CMS",
    quickGoto: "Ir rápidamente a",
    quickGotoHint: "Salta directamente a las secciones que más usas.",
    greetingMorning: "Buenos días",
    greetingAfternoon: "Buenas tardes",
    greetingEvening: "Buenas noches",
    heroSummary: "Actualmente gestionas {count} elementos de contenido en el sitio.",
    publishRate: "En vivo",
    contentMix: "Mezcla de contenido",
    contentMixHint: "Participación del catálogo por sección, de mayor a menor.",
    healthTitle: "Cobertura en vivo",
    healthHint: "Cuánto de cada sección ya es público.",
    liveOfTotal: "{live} de {total} en vivo",
    items: "Ítems",
    people: "Personas",
    attention: {
      maintenanceTitle: "El modo mantenimiento está activo",
      maintenanceMeta: "Los visitantes ven la página en construcción. Gestiona la configuración.",
      reviewsTitle: "{count} reseñas pendientes",
      reviewsMeta: "Aprueba o rechaza reseñas de visitantes.",
      inboxTitle: "{count} mensajes nuevos",
      inboxMeta: "Abre la bandeja de contacto para responder."
    },
    stats: {
      activities: "Actividades",
      stories: "Historias",
      pages: "Páginas",
      reviews: "Reseñas",
      contactMessages: "Mensajes de contacto",
      guiders: "Guías",
      teamMembers: "Miembros del equipo",
      public: "Público",
      pending: "Pendiente",
      new: "Nuevos"
    },
    maintenance: {
      title: "Mantenimiento del sitio",
      on: "Activado",
      off: "Desactivado",
      manage: "Gestionar"
    }
  },
  pages: {
    title: "Páginas",
    createNew: "Crear Nueva Página",
    createPage: "Crear Página",
    editPage: "Editar Página",
    status: "Estado",
    pageType: "Tipo de Página",
    customUrl: "URL Personalizada",
    customUrlHelp: "El slug de URL para este idioma (ej., \"sobre-nosotros\", \"over-ons\"). Cada idioma puede tener su propia URL.",
    pageTypeOptions: {
      custom: "Personalizada",
      about: "Acerca de Nosotros",
      terms: "Términos y Condiciones",
      privacy: "Política de Privacidad"
    },
    statusOptions: {
      draft: "Borrador",
      published: "Publicado"
    },
    searchPlaceholder: "Buscar páginas...",
    filters: {
      public: "Solo Públicas"
    },
    list: {
      emptyStateTitle: "Aún no hay páginas",
      emptyStateHint: "Crea tu primera página para comenzar a construir el contenido de tu sitio web."
    },
    publishSuccess: "Página publicada exitosamente",
    unpublishSuccess: "Página movida a estado de borrador",
    deleteSuccess: "Página eliminada exitosamente",
    isFeatured: "Página Destacada",
    translationsSection: "Traducciones",
    pageTitle: "Título de la Página",
    content: "Contenido",
    seoTitle: "Título SEO",
    seoDescription: "Descripción SEO",
    seoKeywords: "Palabras Clave SEO",
    seoKeywordsPlaceholder: "Agregar palabra clave",
    generalInfo: "Información General",
    order: "Orden",
    orderHelp: "Orden de visualización para ordenar",
    relationshipsSection: "Relaciones",
    relatedActivities: "Actividades Relacionadas",
    relatedActivitiesHelp: "Vincula actividades CMS para mostrar en esta página",
    relatedActivitiesPlaceholder: "Buscar actividades CMS...",
    mediaSection: "Medios",
    featuredImage: "Imagen Destacada",
    featuredImageHelp: "Tamaño recomendado: 1920x1080px",
    featuredImageAlt: "Texto alternativo de la imagen destacada",
    featuredImageAltHelp: "Describe la imagen para accesibilidad y SEO.",
    uploadFeatured: "Guardar Imagen Destacada"
  },
  menus: {
    title: "Menús",
    createNew: "Crear Nuevo Elemento de Menú",
    createMenu: "Crear Elemento de Menú",
    editMenu: "Editar Elemento de Menú",
    generalInfo: "Información General",
    publishing: "Publicación",
    menuLabel: "Etiqueta del Menú",
    menuType: "Tipo de Menú",
    menuTypeOptions: {
      page: "Página",
      link: "Enlace Externo",
      category: "Categoría",
      activity: "Actividad"
    },
    parentMenu: "Menú Principal",
    parentMenuPlaceholder: "Selecciona el menú principal (opcional)",
    parentMenuHelp: "Déjalo vacío para elementos de menú de nivel superior",
    pageLink: "Página",
    pageLinkPlaceholder: "Selecciona una página",
    activityLink: "Actividad",
    activityLinkPlaceholder: "Selecciona una actividad",
    activityRequired: "Por favor selecciona una actividad",
    externalUrl: "URL Externa",
    externalUrlPlaceholder: "https://ejemplo.com",
    categorySlug: "Slug de Categoría",
    categorySlugPlaceholder: "slug-de-categoria",
    order: "Orden",
    orderHelp: "Orden de visualización en el menú",
    status: "Estado",
    statusOptions: {
      draft: "Borrador",
      published: "Publicado"
    },
    searchPlaceholder: "Buscar elementos de menú...",
    filters: {
      public: "Solo Públicas"
    },
    list: {
      emptyStateTitle: "Aún no hay elementos de menú",
      emptyStateHint: "Crea tu primer elemento de menú para comenzar a construir tu navegación."
    },
    publishSuccess: "Elemento de menú publicado exitosamente",
    unpublishSuccess: "Elemento de menú movido a estado de borrador",
    deleteSuccess: "Elemento de menú eliminado exitosamente",
    reorderSuccess: "Elementos de menú reordenados exitosamente",
    failedToLoadActivities: "Error al cargar actividades",
    noActivitiesFound: "No se encontraron actividades",
    translationsSection: "Traducciones",
    menuLabelHelp: "El texto mostrado en el menú",
    translationValidationError: "Por favor completa todos los campos requeridos",
    pageRequired: "Por favor selecciona una página",
    externalUrlRequired: "Por favor ingresa una URL externa",
    categorySlugRequired: "Por favor ingresa un slug de categoría",
    expandAll: "Expandir Todo",
    collapseAll: "Contraer Todo"
  },
  activityCategories: {
    title: "Categorías de Actividades",
    addNew: "Agregar Nueva Categoría",
    existingCategories: "Categorías Existentes",
    noCategories: "No se encontraron categorías. Crea tu primera categoría arriba.",
    manageCategories: "Gestionar Categorías",
    slug: "Slug",
    slugPlaceholder: "ej., caminar, andar en bicicleta, senderismo",
    name: "Nombre",
    order: "Orden",
    icon: "Icono",
    uploadIcon: "Subir Icono",
    iconHelp: "Sube un icono SVG para esta categoría (recomendado: 48x48px)",
    isPublic: "Público",
    createSuccess: "Categoría creada exitosamente",
    updateSuccess: "Categoría actualizada exitosamente",
    deleteSuccess: "Categoría eliminada exitosamente",
    editCategory: "Editar Categoría",
    reset: "Restablecer"
  },
  storyCategories: {
    title: "Categorías de Historias",
    addNew: "Agregar Nueva Categoría",
    existingCategories: "Categorías Existentes",
    noCategories: "No se encontraron categorías. Crea tu primera categoría arriba.",
    type: "Tipo",
    types: {
      destination: "Destino",
      topic: "Tema"
    },
    parent: "Categoría Padre",
    rootCategory: "— Raíz (sin padre)",
    slug: "Slug",
    slugPlaceholder: "ej., camino-frances, mallorca",
    name: "Nombre",
    order: "Orden",
    isPublic: "Público",
    editCategory: "Editar Categoría",
    createSuccess: "Categoría creada exitosamente",
    updateSuccess: "Categoría actualizada exitosamente",
    deleteSuccess: "Categoría eliminada exitosamente",
    reset: "Restablecer"
  },
  media: "Multimedia"
};
